// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__SSNVW","title":"card_title__1Bz0v","inActive":"card_inActive__17D08"};